export function ManageHolidaysCtrl ($uibModalInstance, $scope, $translate, messages, workshopAPI, holidays) {
  $scope.holidays = holidays;
  $scope.selectedItems = [];

  $scope.tableSettings = {
    columns: [
      {
        classes: 'text-left',
        field  : 'date',
        header : {
          classes: 'text-left',
          text   : $translate.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe   : 'globalDate',
      },
      {
        classes: 'text-left',
        field  : 'day_of_week',
        header : {
          classes: 'text-left',
          text   : $translate.instant('BOOKING_SPACE.WEEKDAY')
        },
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_HOLIDAYS_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true,
        multi  : true
      }
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  $scope.onRowClick = function () {
    $scope.selectedItems = $scope.holidays.filter((row) => row.selected);
  };

  $scope.delete = function () {
    angular.forEach($scope.selectedItems, holiday => {
      workshopAPI.delete('/unavailable_time', holiday.id).then(() => {
        $uibModalInstance.close();
      }).catch(err => {
        messages.error(err);
      });
    });

    $uibModalInstance.close();
  };
}
